import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';

import App from './App.js';
import './i18n';

var mountNode = document.getElementById('root');
ReactDOM.render(<App />, mountNode);
